/**
 * Flag to skip expensive table sync during menu toggle transition.
 * Navbar sets true on click, false after transition. MeasureIndicators disconnects observers when true.
 */
let isTransitioning = false;
let transitionEndTimer: ReturnType<typeof setTimeout> | null = null;

const MENU_TRANSITION_START = 'menu-transition-start';
const MENU_TRANSITION_END = 'menu-transition-end';

export const setMenuTransitioning = (value: boolean, durationMs = 250) => {
  if (transitionEndTimer) {
    clearTimeout(transitionEndTimer);
    transitionEndTimer = null;
  }
  isTransitioning = value;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(value ? MENU_TRANSITION_START : MENU_TRANSITION_END));
  }
  if (value) {
    transitionEndTimer = setTimeout(() => {
      isTransitioning = false;
      transitionEndTimer = null;
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(MENU_TRANSITION_END));
      }
    }, durationMs);
  }
};

export const isMenuTransitioning = () => isTransitioning;

export const onMenuTransitionStart = (cb: () => void) => {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(MENU_TRANSITION_START, cb);
  return () => window.removeEventListener(MENU_TRANSITION_START, cb);
};

export const onMenuTransitionEnd = (cb: () => void) => {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(MENU_TRANSITION_END, cb);
  return () => window.removeEventListener(MENU_TRANSITION_END, cb);
};
